const assetsRootPrefix = process.env.NODE_ENV === "development" ? "src/" : "";

const soundsPath = "sounds"

export default {
  game: {
    width: window.innerWidth,
    height: window.innerHeight,
    variationName: "fafafa",
    multiplierAmount: 1,
    chosenLines: 25,
    gameMode: {
      DEFAULT: "normal",
      NORMAL: "normal",
      AUTO_10: {
        value: "auto (10)",
        count: 10,
      },
      AUTO_25: {
        value: "auto (25)",
        count: 25,
      },
      AUTO_50: {
        value: "auto (50)",
        count: 50,
      },
      AUTO_75: {
        value: "auto (75)",
        count: 75,
      },
      AUTO_100: {
        value: "auto (100)",
        count: 100,
      },
    },
    spinMode: {
      DEFAULT: "normal",
      NORMAL: "normal",
      QUICK: "quick",
    },
    volume: {
      default: 1,
      background: 0.4,
    },
    spinModeDuration: {
      NORMAL: 1130,
      QUICK: 630,
    },
  },
  assets: {
    root: assetsRootPrefix + "assets",
    general: [
      {
        name: "background",
        path: "background.jpg",
        width: 1920,
        height: 1080,
      },
      {
        name: "bonusFrame",
        path: "bonus-frame.png",
        width: 1300,
        height: 894,
      },
      {
        name: "symbolFrameBg",
        path: "symbol-frame-bg.png",
        width: 1278,
        height: 782,
      },
      {
        name: "curtain-bg",
        path: "curtain-bg.png",
      },
      {
        name: "curtain-piece",
        path: "curtain-piece.png",
      },
      {
        name: "fortune-wheel-bg",
        path: "fortune-wheel-bg.png",
      },
      {
        name: "fortune-wheel",
        path: "fortune-wheel.png",
      },
      {
        name: "buy-bonus",
        path: "buy-bonus.png",
      },
      {
        name: "wheel-spin",
        path: "wheel-spin.png",
      },
      {
        name: "jackpots-bg",
        path: "jackpots-bg.png",
      },
      {
        name: "button-auto-spin-10-selected",
        path: "control_panel/button-auto-spin-10-selected.png",
      },
      {
        name: "button-auto-spin-10",
        path: "control_panel/button-auto-spin-10.png",
      },{
        name: "button-auto-spin-25-selected",
        path: "control_panel/button-auto-spin-25-selected.png",
      },{
        name: "button-auto-spin-25",
        path: "control_panel/button-auto-spin-25.png",
      },{
        name: "button-auto-spin-50-selected",
        path: "control_panel/button-auto-spin-50-selected.png",
      },{
        name: "button-auto-spin-50",
        path: "control_panel/button-auto-spin-50.png",
      },{
        name: "button-auto-spin-100-selected",
        path: "control_panel/button-auto-spin-100-selected.png",
      },
      {
        name: "button-auto-spin-100",
        path: "control_panel/button-auto-spin-100.png",
      }
      ,{
        name: "button-auto-spin-500-selected",
        path: "control_panel/button-auto-spin-500-selected.png",
      },
      {
        name: "button-auto-spin-500",
        path: "control_panel/button-auto-spin-500.png",
      }
      ,{
        name: "button-auto-spin-1000-selected",
        path: "control_panel/button-auto-spin-1000-selected.png",
      },
      {
        name: "button-auto-spin-1000",
        path: "control_panel/button-auto-spin-1000.png",
      },{
        name: "button-auto-spin-bg",
        path: "control_panel/button-auto-spin-bg.png",
      },{
        name: "button-bet-bg",
        path: "control_panel/button-bet-bg.png",
      },{
        name: "button-bet-minus",
        path: "control_panel/button-bet-minus.png",
      },{
        name: "button-bet-plus",
        path: "control_panel/button-bet-plus.png",
      },{
        name: "button-buy-chip",
        path: "control_panel/button-buy-chip.png",
      },{
        name: "button-close",
        path: "control_panel/button-close.png",
      },{
        name: "button-fast-selected",
        path: "control_panel/button-fast-selected.png",
      },{
        name: "button-fast",
        path: "control_panel/button-fast.png",
      },{
        name: "button-info-bg",
        path: "control_panel/button-info-bg.png",
      },{
        name: "button-info",
        path: "control_panel/button-info.png",
      },{
        name: "button-lobby",
        path: "control_panel/button-lobby.png",
      },{
        name: "button-maxbet-bg",
        path: "control_panel/button-maxbet-bg.png",
      },{
        name: "button-maxbet-selected",
        path: "control_panel/button-maxbet-selected.png",
      },{
        name: "button-maxbet",
        path: "control_panel/button-maxbet.png",
      },{
        name: "button-menu",
        path: "control_panel/button-menu.png",
      },{
        name: "button-music-off",
        path: "control_panel/button-music-off.png",
      },{
        name: "button-music-on",
        path: "control_panel/button-music-on.png",
      },
      {
        name: "button-sound-off",
        path: "control_panel/button-sound-off.png",
      },{
        name: "button-sound-on",
        path: "control_panel/button-sound-on.png",
      },{
        name: "button-spin",
        path: "control_panel/button-spin.png",
      },{
        name: "button-stop",
        path: "control_panel/button-stop.png",
      },{
        name: "chip-panel-bg",
        path: "control_panel/chip-panel-bg.png",
      },{
        name: "menu-panel-bg",
        path: "control_panel/menu-panel-bg.png",
      },{
        name: "panel-bg",
        path: "control_panel/panel-bg.png",
      },{
        name: "spin-bg",
        path: "control_panel/spin-bg.png",
      },{
        name: "down-arrow",
        path: "control_panel/down-arrow.png",
      },
      {
        name: "modal-bg",
        path: "menu_icons/menu-frame.png",
      },
      {
        name: "close",
        path: "close.png",
      },
      {
        name: "check",
        path: "check.png",
      },
    ],
    sounds: [
      {
        name: "background",
        url: `${soundsPath}/background1.mp3`,
      },
      {
        name: "background_slow",
        url: `${soundsPath}/background2.mp3`,
      },
      {
        name: "royals",
        url: `${soundsPath}/royals.mp3`,
      },
      {
        name: "chengiz",
        url: `${soundsPath}/chengiz.mp3`,
      },
      {
        name: "horse",
        url: `${soundsPath}/horse.mp3`,
      },
      {
        name: "knife",
        url: `${soundsPath}/knife.mp3`,
      },
      {
        name: "orchid",
        url: `${soundsPath}/orchid.mp3`,
      },
      {
        name: "vase",
        url: `${soundsPath}/vase.mp3`,
      },
      {
        name: "start",
        url: `${soundsPath}/start.mp3`,
      },
      {
        name: "stop",
        url: `${soundsPath}/stop.mp3`,
      },
      {
        name: "freespins",
        url: `${soundsPath}/freespins.mp3`,
      },
      {
        name: "wild",
        url: `${soundsPath}/wild.mp3`,
      },
      {
        name: "win",
        url: `${soundsPath}/win.mp3`,
      },
      {
        name: "normal-win",
        url: `${soundsPath}/normal-win.mp3`,
      },
      {
        name: "popup",
        url: `${soundsPath}/popup.mp3`,
      },
      {
        name: "ui",
        url: `${soundsPath}/ui.mp3`,
      },
      {
        name: "wheel-start",
        url: `${soundsPath}/wheel-start.mp3`,
      },
      {
        name: "wheel-loop",
        url: `${soundsPath}/wheel-loop.mp3`,
      },
      {
        name: "reel-frame",
        url: `${soundsPath}/reel-frame.mp3`,
      },
    ],
    symbol: {
      root: "sprites",
      animatedSprites: [
        {
          name: "expandedWild",
          num: 13,
          path: "expandedWild.json",
          animationName: "expandedWild",
        },
        {
          name: "scatter",
          num: 12,
          path: "scatter.json",
          animationName: "scatter",
        },
        {
          name: "wild",
          num: 11,
          path: "wild.json",
          animationName: "wild",
        },
        {
          name: "chengiz",
          num: 10,
          path: "chengiz.json",
          animationName: "chengiz",
        },
        {
          name: "horse",
          num: 9,
          path: "horse.json",
          animationName: "horse",
        },
        {
          name: "knife",
          num: 8,
          path: "knife.json",
          animationName: "knife",
        },
        {
          name: "vase",
          num: 7,
          path: "vase.json",
          animationName: "vase",
        },
        {
          name: "orchid",
          num: 6,
          path: "orchid.json",
          animationName: "orchid",
        },
        {
          name: "ace",
          num: 5,
          path: "ace.json",
          animationName: "ace",
        },
        {
          name: "king",
          num: 4,
          path: "king.json",
          animationName: "king",
        },
        {
          name: "queen",
          num: 3,
          path: "queen.json",
          animationName: "queen",
        },
        {
          name: "jack",
          num: 2,
          path: "jack.json",
          animationName: "jack",
        },
        {
          name: "ten",
          num: 1,
          path: "ten.json",
          animationName: "ten",
        },
        {
          name: "nine",
          num: 0,
          path: "nine.json",
          animationName: "nine",
        },
        {
          name: "scatter-reel-frame",
          num: 99,
          path: "scatter-reel-frame.json",
          animationName: "scatter-reel-frame",
        },
        {
          name: "sensational",
          num: 98,
          path: "sensational.json",
          animationName: "sensational",
        },
        {
          name: "super",
          num: 97,
          path: "super.json",
          animationName: "super",
        },
        {
          name: "nice",
          num: 96,
          path: "nice.json",
          animationName: "nice",
        },
        {
          name: "minor",
          num: 95,
          path: "minor.json",
          animationName: "minor",
        },
        {
          name: "major",
          num: 94,
          path: "major.json",
          animationName: "major",
        },
        {
          name: "grand",
          num: 93,
          path: "grand.json",
          animationName: "grand",
        },
      ],
    },
  },
};
